import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-top-counter",
  templateUrl: "./top-counter.component.html",
  styleUrls: ["./top-counter.component.css"]
})
export class TopCounterComponent implements OnInit {
  @Input() Title1: string;
  @Input() Title2: string;

  @Input() Count1: number;
  @Input() Count2: number;
  @Input() Count3: number;
  @Input() currency: boolean;
  @Input() nocurrency2: boolean;

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/partial/top-counter/top-counter.component.ts